export default __webpack_public_path__ + "static/media/bg-masthead-1-640w.1f95513d.webp";